import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedSeries } from 'src/app/models/dashboard';
import { MultiSourceMultiValueWidget } from "../../base/MultiSourceMultiValueWidget";
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { FreeTextWidgetComponent } from '../free-text-widget/free-text-widget.component';

declare var require: any
var jp = require('jsonpath');


@Component({
  selector: 'app-multi-text-widget',
  templateUrl: './multi-text-widget.component.html',
  styleUrls: ['./multi-text-widget.component.css']
})
export class MultiTextWidgetComponent extends MultiSourceMultiValueWidget {
  @ViewChild('dynamicTemplate') dynamicTemplate: ElementRef;
  html: string;
  dataDict: any;
  public c: any;
  w: any;
  //_uriLookup: any;

  liveDataOnly(): boolean {
    return (<any>this.widget).period == null || (<any>this.widget).period == "";
  }

  override eventTypes: string[]; 
  override timeSeriesEvent(type: string, uri: string): void {
    
  }

  widgetBeforeInit(): void {
    this.w = <any>this.widget;
    this.html = this.w.html;
    this.dataDict = {};
    //this._uriLookup = {};
    this.c = <any>this.config;
  }

  override widgetDataLoadComplete(): void {
      
  }

  widgetAfterInit(): void {
  
  }

  widgetDataLoaded(series: SharedSeries): void {
    let index = 0;
    if (Object.keys(this.dataDict).length === 0) {
      for (let i = 0; i < this.c.dynamicTimeSeriesList.length; i++) {
        this.dataDict[this.c.dynamicTimeSeriesList[i].name] = {}
        //this._uriLookup[i] = this.c.timeSeriesDetailList[i].name
      }
      
    }

    let match = false;
    for (let i = 0; i < this.c.dynamicTimeSeriesList.length; i++) {
      if (this.c.dynamicTimeSeriesList[i].tagMatches == null || this.c.dynamicTimeSeriesList[i].tagMatches.length == 0) {
        //we match based on uri
        if (this.c.dynamicTimeSeriesList[i].uri == series.uri) {
          index = i;
          match = true;
        }
      }
      else {
        //we match based on tags
        let matchedTags = 0;
        for (let tag of this.c.dynamicTimeSeriesList[i].tagMatches) {
          if(series.metaData != null && series.metaData.hasOwnProperty(tag.tagName) && series.metaData[tag.tagName] == tag.tagValue){
            matchedTags++;
          }
        }
        if(matchedTags == this.c.dynamicTimeSeriesList[i].tagMatches.length){
          index = i;
          match = true;
        }
      }
    }

    if(match == false){
      console.warn('no match found for series:', series.uri);
      return;
    }

    if (series) {
      var last = series.values == null ? null : series.values[series.values.length - 1];
      if (last != null && typeof last.value == "string" && last.value.startsWith("{")) {    
        // if this entry is a dynamic entry, then we need to add to a list
        if (this.c.dynamicTimeSeriesList[index].dynamic){   
          if (this.dataDict.list == null) this.dataDict.list = [];
          this.dataDict.list.push({ series: series, timeStamp: last.timeStamp, data: JSON.parse(last.value), latitude: series.latitude, longitude: series.longitude, metaData: series.metaData });
        }        
        this.dataDict[this.c.dynamicTimeSeriesList[index].name] = { series: series, timeStamp: last.timeStamp, data: JSON.parse(last.value), latitude: series.latitude, longitude: series.longitude, metaData: series.metaData };
      }
      else {
        if (this.c.dynamicTimeSeriesList[index].dynamic){   
          if (this.dataDict.list == null) this.dataDict.list = [];
          this.dataDict.list.push({ series: series, timeStamp: last?.timeStamp, data: last?.value, latitude: series.latitude, longitude: series.longitude, metaData: series.metaData });
        }    
        this.dataDict[this.c.dynamicTimeSeriesList[index].name] = { series: series, timeStamp: last?.timeStamp, data: last?.value, latitude: series.latitude, longitude: series.longitude, metaData: series.metaData };
      }
    }

    if (Object.keys(this.dataDict).length === 1 && this.dynamicTemplate){
        (this.dynamicTemplate as any).set(this.dataDict[Object.keys(this.dataDict)[0]]);
    }
    else if (this.dynamicTemplate){
      (this.dynamicTemplate as any).set(this.dataDict);
    }

  }

  widgetDataLoadTimeout(){
    
  }
  
  widgetLiveDataLoaded(point: any): void {
    
    var series: SharedSeries = {} as SharedSeries;
    series.uri = point.uri;
    series.values = [];
    series.values.push(point.point);
    
    this.widgetDataLoaded(series);
  }

  
}
